import { Controller } from "@hotwired/stimulus";

const FORMATS = {
  short: { month: "2-digit", day: "2-digit", year: "numeric" },
  long: { month: "long", day: "2-digit", year: "numeric" },
  datetime: {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  },
};

export default class extends Controller {
  static values = {
    timestamp: String,
    format: { type: String, default: "short" },
  };

  connect() {
    const date = new Date(this.timestampValue);
    if (isNaN(date)) return;

    this.element.textContent = date.toLocaleString(
      "en-US",
      FORMATS[this.formatValue] || FORMATS.short,
    );
  }
}
